import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IPublicEmployeeInfoDto } from '@/dtos';

import { FRAUD_REVIEW_STATUS_QUERY_KEY } from '../fraudReview.constants';

export interface FraudReviewStatus {
  isFraudReviewRequired: boolean;
  fraudReviewRequiredAt?: string;
}

const useFraudReviewStatusQuery = (employeeId?: string, enabled = true) => {
  const { data, isLoading, refetch } = useQuery(
    [FRAUD_REVIEW_STATUS_QUERY_KEY, employeeId],
    () => api.get<IPublicEmployeeInfoDto>(API_URL.EMPLOYEES_BY_EMPLOYEE_ID(employeeId || '')),
    {
      enabled: enabled && Boolean(employeeId),
    }
  );

  const status = useMemo<FraudReviewStatus>(() => {
    const payload = data?.data as
      | (IPublicEmployeeInfoDto & Partial<FraudReviewStatus>)
      | undefined;
    const flaggedAt = payload?.fraudReviewRequiredAt ?? payload?.fraud_review_required_at;

    return {
      isFraudReviewRequired: Boolean(
        payload?.isFraudReviewRequired ?? payload?.is_fraud_review_required
      ),
      fraudReviewRequiredAt: flaggedAt ? new Date(flaggedAt).toISOString() : undefined,
    };
  }, [data]);

  return {
    ...status,
    isLoading,
    refetch,
  };
};

export default useFraudReviewStatusQuery;
